/* @flow */

import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import type { RootState } from '../../types'
import { clearPollsStore } from '../../stores/pollsStore'
import { clearFeaturedPolls } from '../../stores/polls/featured'
import { fetchPollsIntoStore } from '../../sagas/fetchPolls'
import { clearCursors } from '../../stores/cursoredUrlsStore'
import { clearAutomatedPolls } from '../polls/automated'

type Action = {
  type: string,
  payload?: string,
}

export const SET_SEARCH = 'opinary/setSearch'
export const CLEAR_SEARCH = 'opinary/clearSearch'

export function clearSearch(): Action {
  return {
    type: CLEAR_SEARCH,
  }
}

export function setSearch(search: string): Action {
  return {
    type: SET_SEARCH,
    payload: search,
  }
}

export function getSearch(state: RootState): ?string {
  return state.ui.search
}

export default function reducer(
  state: ?string = null,
  { type, payload }: Action
) {
  switch (type) {
    case CLEAR_SEARCH:
      return null
    case SET_SEARCH:
      return payload
    default:
      return state
  }
}

export function* clearOnSearchChange(): Generator<*, void, *> {
  yield takeEvery([SET_SEARCH, CLEAR_SEARCH], function*() {
    yield put(clearPollsStore())
    yield put(clearFeaturedPolls())
    yield put(clearAutomatedPolls())
    yield put(clearCursors())
  })
}

export function* fetchOnSearchChange(): Generator<*, void, *> {
  yield takeLatest(SET_SEARCH, function*() {
    yield call(delay, 500)
    yield put(fetchPollsIntoStore())
  })
}



// WEBPACK FOOTER //
// ./src/stores/ui/search.js